export default __webpack_public_path__ + "static/media/create_lead.6e42f5c8.svg";